export const TypeOfActivityList = [
  {
    id: 1,
    label: 'Task',
  },
  {
    id: 2,
    label: 'Information',
  },
  {
    id: 3,
    label: 'Training',
  },
];

export const TypeOfActivityConst = {
  TASK: 1,
  INFORMATION: 2,
  TRAINING: 3,
};
